import React from 'react';
import { Typography, Box } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { red } from '@mui/material/colors';
interface ErrorIndicatorProps {
  text: string;
}

const ErrorIndicator: React.FC<ErrorIndicatorProps> = ({ text }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
      <ErrorIcon sx={{ color: red[500], fontSize: 50  }}  />
      <Typography variant="body1" mt={2}  sx={{ color: red[500], fontSize: 14  }}>
        {text}
      </Typography> 
    </Box>
  );
};

export default ErrorIndicator
